import * as React from "react";
import { resolveDiagramSvgHeight } from "../shared/diagramSvgDimensions";


import { MethylationMethylationDiagramContent } from "./MethylationMethylationDiagram";
import { MethylationMethylationKeyContent } from "./MethylationMethylationKey";

const SvgMethylationMethylationDiagramKey = ({
  geneColors = {},
  expectedSnps = {},
  showKey = true,
  keyControlsId = "diagram-key",
  onGeneClick,
  width: widthProp,
  height: heightProp,
  ...props
}) => {
  const diagramOnly = !showKey;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
      width={widthProp ?? 1424}
      height={resolveDiagramSvgHeight(heightProp, diagramOnly, 869, 1081)}
      viewBox={diagramOnly ? "0 212 1424 869" : "0 0 1424 1081"}
    >
      <g id="methylation-methylation-diagram+key" clipPath="url(#clip0_18291_211496)">
        <rect width={1424} height={diagramOnly ? 869 : 1081} fill="white" />
        {showKey && (
          <g id={keyControlsId}>
            <MethylationMethylationKeyContent />
          </g>
        )}
        <MethylationMethylationDiagramContent
          geneColors={geneColors}
          expectedSnps={expectedSnps}
          onGeneClick={onGeneClick}
        />
      </g>
      <defs>
        <clipPath id="clip0_18291_211496">
          <rect width={1424} height={1081} fill="white" />
        </clipPath>
        <clipPath id="clip1_18291_211496">
          <rect width={1424} height={869} fill="white" transform="translate(0 212)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgMethylationMethylationDiagramKey;
